import { Component, OnInit, Input } from '@angular/core';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'personal-queue',
  templateUrl: './personal-queue.component.html',
  styleUrls: ['./personal-queue.component.scss'],
  providers: []
})
export class PersonalQueueComponent implements OnInit {
  data: any = '';
  loading = true;
  errors = [];
  @Input() last = false;

  constructor() { }

  ngOnInit() {
    this.data = '8';
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/personal-queue/personal-queue.component.ts